import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const AuthenticatedRoute = ({
  component: C, props: cProps, groupCheck = () => true, ...rest
}) =>
  (<Route
    render={(props) => {
      if (!cProps.isAuthenticated) {
        return <Redirect to={`/login?redirect=${props.location.pathname}${props.location.search}`} />;
      } else if (!groupCheck(cProps)) {
        return <Redirect to="/" />;
      }
      return <C {...props} {...cProps} {...rest} />;
    }}
  />);

AuthenticatedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  groupCheck: PropTypes.func,
  props: PropTypes.object,
  location: PropTypes.object,
};

export default AuthenticatedRoute;



// WEBPACK FOOTER //
// ./src/components/AuthenticatedRoute.js